module.exports = __webpack_public_path__ + "static/media/ClinicalIconColor.b7216b59.png";